/**
 * How a message got there: field rules say `validate`; this one and CLIENT_ERROR
 * (hooks/useClientErrors) are set from outside.
 */
export const SERVER_ERROR = 'server';

export function isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}

/** Whether any field holds a message of `type`, such as one a save's 400 set. */
export function hasErrorOfType(errors: unknown, type: string): boolean {
    const pending: unknown[] = [errors];
    while (pending.length > 0) {
        const node = pending.pop();
        if (!isRecord(node)) continue;
        if (typeof node.type === 'string') {
            if (node.type === type) return true;
            continue;
        }
        pending.push(...Object.values(node));
    }
    return false;
}
